<template>
  <DBox
    id="custom-checklist"
    :addButton="false"
    :topRightMenu="[
      {
        text: 'lock',
        icon: iconSrc,
        value: 'lock',
      },
    ]"
    :leftMenu="
      !canEdit
        ? [
            {
              text: 'Unlock To Edit CheckList',
              value: 'unlock-to-edit-check-list',
              label: true,
            },
          ]
        : [
            {
              text:`+ ${$t('add_new_checklist_item')}`,
              value: 'add_new',
            },
          ]
    "
    @menuClick="onMenuClick"
  >
    <div class="dt-list">
      <div
        class="ut-flex ut-rowh"
        style="
          justify-content: flex-end;
          border-bottom: 1px solid var(--sprt-85);
        "
        v-for="cl of custom_checklist"
        :key="cl.name"
      >
        <div style="flex: 1">
          <TextField2
            type="text"
            class="dbox1"
            :id="cl.name"
            :showLabel="false"
            :disabled="!canEdit"
            :value="cl.name"
            :bb="'0px'"
            placeholder="..."
            @change="(e) => onTextFieldChange(e)"
          />
        </div>
        <div style="flex: 0.75">
          <span style="margin-left: 8px">{{ cl.user_name }} {{ getDate(cl) }}</span>
        </div>

        <div class="ut-flex ut-minw30">
          <div class="dt-checkbox v2 s1">
            <input
              type="checkbox"
              :name="cl.name"
              :id="cl.name"
              :checked="cl.checklist_id"
              style="margin-left: auto; margin-right: auto"
              @click="(e) => onCheckboxChange(e, cl)"
            />
            <div class="checkmark"></div>
          </div>
        </div>
        <div
          style="
            width: 1px;
            height: 30px;
            border-left: 1px solid var(--sprt-85);
          "
        ></div>
        <div class="ut-flex ut-rowcen ut-minw30">
          <div class="dt-icon-container">
            <img
              src="static/icons/delete.svg"
              class="dt-icon v5 s1"
              :alt="$t('delete_custom_checklist_item')"
              :title="$t('delete_custom_checklist_item')"
              @click="deleteChecklistItem(cl)"
            />
          </div>
        </div>
      </div>
      <!-- <div class="dt-list-item" v-for="cl of custom_checklist" :key="cl.name">
        <div class="dt-list-item--body">
          
          <TextField2
            type="text"
            class="dbox1"
            :id="cl.name"
            :showLabel="false"
            :disabled="!canEdit"
            :value="cl.name"
            :bb="'0px'"
             placeholder="..."
             @change="(e) => onTextFieldChange(e, item)"
            />  
        
        
          <div class="dt-list-item--text">{{ cl.name }}</div>
          <div class="dt-list-item--text">
            {{ cl.timestamped ? $dft.date(cl.timestamped) + "," : "" }}
            {{ cl.user_name ? cl.user_name : "" }}
          </div>
        
        
        </div>
        <div class="dt-list-item--options">
          <div class="dt-checkbox v2 s1">
            <input
              type="checkbox"
              :name="cl.name"
              :id="cl.name"
              :checked="cl.checklist_id"
              @click="(e) => onCheckboxChange(e, cl)"
            />
            <div class="checkmark"></div>
          </div>
        </div>
      </div> -->
    </div>
    <template v-if="addCustomChecklistModalContainer">
      <v-dialog v-model="addCustomChecklistModal" persistent width="390">
        <AddChecklist
          v-on:ADD_NEW="addNewChecklist"
          v-on:CANCEL="onCancelAdd"
        ></AddChecklist>
      </v-dialog>
    </template>

    <template v-if="editCustomChecklistModalContainer">
      <v-dialog v-model="editCustomChecklistModal" persistent width="390">
        <EditChecklist
          :customChecklists="custom_checklist"
          v-on:EDIT="editChecklistItem"
          v-on:OPEN_ADD="openAddCCModal"
          v-on:DELETE="deleteChecklistItem"
          v-on:CANCEL="onCancelEdit"
        ></EditChecklist>
      </v-dialog>
    </template>
    <!-- <div class="dbox-title-bar--options">
      <img
        @click="openEditCCModal"
        src="static/icons/edit.svg"
        class="dt-icon v4"
        alt="Edit Custom Checklist"
        title="Edit Custom Checklist"
      />
      <img
        @click="openAddCCModal"
        src="static/icons/add-icon-blue.svg"
        class="dt-icon v4"
        alt="Add Custom Checklist"
        title="Add Custom Checklist"
      />
    </div> -->
  </DBox>
</template>

<script>
import AddChecklist from "../../../../dt-plugins/custom-checklist/add-checklist";
import EditChecklist from "../../../../dt-plugins/custom-checklist/edit-checklist";
import {
  createModalMixin,
  openModalRoute,
  closeModalRoute,
} from "../../../../dt-plugins/modal/modal.mixin";

export default {
  components: {
    AddChecklist,
    EditChecklist,
  },
  props: ["booking", "booking"],
  data: function () {
    return {
      addDialog: false,
      editDialog: false,
      canEdit: true,
    };
  },
  computed: {
    iconSrc: function () {
      return this.canEdit ? "lock-open.svg" : "lock-closed.svg";
    },
    custom_checklist: function () {
      return ((this.booking && this.booking.custom_checklist) || []).filter(
        (e) => e.name
      );
    },
  },
  mixins: [
    createModalMixin("addCustomChecklist"),
    createModalMixin("editCustomChecklist"),
  ],
  methods: {
    onMenuClick: function (value) {
      console.log(value);

      switch (value) {
        case "lock":
          this.canEdit = !this.canEdit;
          break;
        case "add_new":
          this.openAddCCModal();
          break;
        case "unlock-to-edit-check-list":
          break;

        default:
          break;
      }
    },
    onCheckboxChange(e, cl) {
      const checked = e.target.checked;

      const calendarDateId = this.booking.cdate.calendar_date_id;
      const checklistId = cl.checklist_id;

      if (checked) {
        this.$emit("checked", {
          calendarDateId: calendarDateId,
          checklistItem: cl.name,
        });
      } else {
        this.$emit("unchecked", {
          calendarDateId,
          checklistId,
        });
      }
    },
    openAddCCModal(event) {
      // this.addDialog = !this.addDialog;
      openModalRoute(this, "add_custom_checklist");
    },
    addNewChecklist: function (checklistItem) {
      const calendarDateId = this.booking.cdate.calendar_date_id;
      this.$emit("inserted", {
        calendarDateId,
        checklistItem,
      });
    },
    editChecklistItem: function ({ item, newName }) {
      const calendarDateId = this.booking.cdate.calendar_date_id;

      const oldName = item.item.name;
      console.log("RRRR", item);
      console.log("RRRR", oldName);

      this.$emit("updated", {
        calendarDateId,
        oldName,
        newName,
      });
    },
    onTextFieldChange: function (e) {
      const calendarDateId = this.booking.cdate.calendar_date_id;

      const oldName = e.name;
      const newName = e.value;
      console.log("RRRR", e);
      console.log("RRRR", oldName, newName);

      this.$emit("updated", {
        calendarDateId,
        oldName,
        newName,
      });
    },
    deleteChecklistItem: function (ccItem) {
      if(!this.canEdit){
        return;
      }
      
      const calendarDateId = this.booking.cdate.calendar_date_id;
      this.$emit("deleted", {
        calendarDateId,
        checkListName: ccItem.name,
      });
    },
    onCancelAdd: function (flag) {
      // this.addDialog = flag;
      closeModalRoute(this);
    },
    onCancelEdit: function (flag) {
      // this.editDialog = flag;
      closeModalRoute(this);
    },
    openEditCCModal: function (e) {
      // this.editDialog = !this.editDialog;
      openModalRoute(this, "edit_custom_checklist");
    },

    getDate(cl) {
      return cl?.timestamped?.split(" ")?.[0] || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.dt-list {
  .dt-list-item {
    padding: 5px 10px;
    font-size: 13px;

    display: flex;

    border-bottom: 2px solid var(--sprt-85);

    &--body {
      flex: 1;
    }
    &--options {
      max-width: 10px;
      margin-top: 3px;
    }
  }
}
</style>
